import { dateTimeRequest, filterRequest } from "./common.mapper";
import {
  formatName
} from "services";
import { formatNumberToMoneyWithCurrencySymbol } from "services/money.service";

export const mapPreAuthTransactionResponse = {
  id: {
    key: "transactionId",
  },
  amount: {
    transform: ({ src }) => {
      return formatNumberToMoneyWithCurrencySymbol(src.originalAmount);
    },
  },
  paidAmount: {
    transform: ({ src }) => {
      return formatNumberToMoneyWithCurrencySymbol(src.userTagNewBalance);
    },
  },
  type: {
    key: "type",
  },
  transactionStatus: {
    key: "transactionStatus",
  },
  userTagUid: {
    key: "userTagUid",
  },
  guestId: {
    key: "guestId",
  },
  guestTagId: {
    key: "guestTagId",
  },
  name: {
    transform: ({ src }) => {
      return formatName(src?.firstName, src?.lastName);
    },
  },
};

export const preAuthTransactionListFilterRequest = {
  ...filterRequest,
  ...dateTimeRequest,
};
